import { DiceIcon } from '@/modules/roadmap/sicbo/SicBoIcon';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import { GameResultCellProps } from '..';

export const SicBoGameResult = (props: GameResultCellProps) => {
    const { summary } = props;

    const dices: number[] = summary.Result.split(',').map(str => Number(str));

    return (
        <Stack className="item-sicbo-game-result-container">
            {dices.map((d, idx) => {
                return (
                    <Grid
                        key={`dice-${idx}`}
                        container
                        className="dice-container"
                    >
                        <DiceIcon dices={d} />
                    </Grid>
                );
            })}
        </Stack>
    );
};
